import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import ReviewQuoteIcon from '../../svgs/reviewquote.svg';

interface TestimonialProps {
    header: string;
    description: string;
    author: string;
}

const Testimonial: React.FC<TestimonialProps> = ({ header, description, author }) => {
    return (
        <div className="e2g-testimonial text-center text-white px-5 py-5 font-weight-normal">
            <div className="page-section-inner container-fluid">
                <h2 className="e2g-header_title mb-4 font-weight-light">{header}</h2>
                <Row>
                    <Col md={2}>
                        <ReviewQuoteIcon className="e2g-testimonial_icon" />
                    </Col>
                    <Col md={10}>
                        <div className="e2g-testimonial_quote text-left font-italic font-weight-light">{`"${description}"`}</div>
                        <div className="e2g-testimonial_citation text-left font-weight-bold mt-4">{author}</div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export { Testimonial, TestimonialProps };
